export const LEAD = {
    id: "LeadiDscript_campaign",
    type: "text/javascript",
    async: true,
    crossOrigin: "anonymous",
    src:  "//create.lidstatic.com/campaign/e4127813-533f-79a4-c481-7daca8b33bed.js?snippet_version=2",
    
    wrapperId:"LeadiD-wrapper-element"
}